// extracted by mini-css-extract-plugin
module.exports = {"VenueBuilderApp":"VenueBuilder_VenueBuilderApp__2Jw0I"};